import { DefaultRefreshHandler } from '/workspace/node_modules/@sidebase/nuxt-auth/dist/runtime/utils/refreshHandler'
export const _refreshHandler = new DefaultRefreshHandler({"enablePeriodically":false,"enableOnWindowFocus":true})